/* @flow */

import { transparentize } from 'polished';

import { white } from '@e180/ui/lib/token/palette';

export default {
  root: {},
  avatar: {
    display: 'flex',
    justifyContent: 'center',
  },
  nameCtn: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    margin: '0.5em 0 0',

    '&:not(:last-child):after': {
      content: "''",

      display: 'block',

      width: 30,
      height: 1,
      margin: '0.75rem auto',

      backgroundColor: '#6e6e6e',
    },
  },
  name: {
    fontSize: 17,
  },
  title: {
    maxWidth: '100%',

    color: transparentize(0.33, white),

    fontSize: 15,
    fontStyle: 'italic',
    textAlign: 'center',
    wordWrap: 'break-word',
  },
  social: {
    marginTop: '1.125rem',
  },
};
